import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '~/components/legal-page'
import { getPublicConfig } from '~/functions/session.functions'
import { termsSections } from '~/lib/legal'

export const Route = createFileRoute('/terms')({
  loader: () => getPublicConfig(),
  head: () => ({ meta: [{ title: `${m.legal_terms_title()} - ${m.app_name()}` }] }),
  component: TermsPage,
})

/** The terms of sale and use: public, readable without an account. */
function TermsPage() {
  const { company } = Route.useLoaderData()
  return (
    <LegalPage title={m.legal_terms_title()} sections={termsSections(company)} company={company} />
  )
}
